/**
 * String Helper Functions
 * Utilidades para manipulación de strings
 */

/**
 * Convierte un string a formato slug (URL-friendly)
 *
 * @param text - Texto a convertir
 * @returns String en formato slug
 *
 * @example
 * slugify("Cabaña Básica") // "cabana-basica"
 * slugify("Mesón Premium") // "meson-premium"
 * slugify("  Espacio  con   espacios  ") // "espacio-con-espacios"
 */
export const slugify = (text: string): string => {
  return text
    .toLowerCase()
    .normalize('NFD') // Normalizar caracteres Unicode
    .replace(/[\u0300-\u036f]/g, '') // Eliminar acentos
    .replace(/\s+/g, '-') // Espacios → guiones
    .replace(/[^\w-]+/g, '') // Quitar caracteres especiales
    .replace(/--+/g, '-') // Múltiples guiones → uno solo
    .trim()
}

/**
 * Convierte un slug de vuelta a un formato más legible
 *
 * @param slug - Slug a convertir
 * @returns String con primera letra mayúscula
 *
 * @example
 * unslugify("cabana-basica") // "Cabana basica"
 * unslugify("meson-premium") // "Meson premium"
 */
export const unslugify = (slug: string): string => {
  return slug
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase())
}
